<template>
  <div id="app">
    <no-internet-connection v-if="!isConnected" />

    <component :is="layout">
      <system-notifications/>
      <router-view />
    </component>

    <portal-target name="modals" multiple></portal-target>

    <installed-devices-modal />
    <devices-modal />
    <avatar-profile-picture-modal  />
    <screen-time-modal />
    <app-settings-modal />
    <content-filter-modal />
    <website-settings-modal  />
    <password-change-modal />
    <screentime-exhausted />
    <custom-filter-modal />
    <custom-filter-editor-modal />
    <geofence-list-modal />
    <geofence-configure-modal />
    <request-action-confirm-modal />
    <device-availability-modal />
    <remove-profile-modal />
    <social-media-modal />
  </div>
</template>

<script>
  import InstalledDevicesModal     from '@/components/Modals/InstalledDevicesModal.vue'
  import DevicesModal              from '@/components/Modals/DevicesModal'
  import AvatarProfilePictureModal from '@/components/Modals/AvatarProfilePictureModal.vue'
  import ScreenTimeModal           from '@/components/Modals/ScreenTimeManagementModal.vue'
  import AppSettingsModal          from '@/components/Modals/AppSettingsModal.vue'
  import ContentFilterModal        from '@/components/Modals/ContentFilterModal.vue'
  import WebsiteSettingsModal      from '@/components/Modals/WebsiteSettingsModal.vue'
  import PasswordChangeModal       from '@/components/Modals/PasswordChangeModal.vue'
  import CustomFilterModal         from '@/components/Modals/CustomFilterModal.vue'
  import CustomFilterEditorModal   from '@/components/Modals/CustomFilterEditorModal.vue'
  import ScreentimeExhausted       from '@/components/Modals/ModalScreentimeExhausted.vue'
  import GeofenceListModal         from '@/components/Modals/GeofenceListModal.vue'
  import GeofenceConfigureModal    from '@/components/Modals/GeofenceConfigureModal.vue'
  import RequestActionConfirmModal from '@/components/Modals/RequestActionConfirmModal.vue'
  import DeviceAvailabilityModal   from '@/components/Modals/DeviceAvailabilityModal.vue'
  import RemoveProfileModal        from '@/components/Modals/RemoveProfileModal.vue'
  import SocialMediaModal          from '@/components/Modals/SocialMediaModal.vue'

  import NoInternetConnection      from '@/components/Common/NoInternetConnection.vue'
  import SystemNotifications       from '@/components/Common/SystemNotifications.vue'
  import publishMap                from '@/services/publishMap.js'
  import socket                    from '@/services/socket.js'

  const defaultLayout = 'default'

  export default {
    components: {
      SystemNotifications,
      InstalledDevicesModal,
      DevicesModal,
      AvatarProfilePictureModal,
      ScreenTimeModal,
      AppSettingsModal,
      ContentFilterModal,
      WebsiteSettingsModal,
      PasswordChangeModal,
      ScreentimeExhausted,
      NoInternetConnection,
      CustomFilterModal,
      CustomFilterEditorModal,
      GeofenceListModal,
      GeofenceConfigureModal,
      RequestActionConfirmModal,
      DeviceAvailabilityModal,
      RemoveProfileModal,
      SocialMediaModal
    },

    data() {
      return {
        socketChannel: null,
        isConnected: true
      }
    },

    created() {
      socket
        .on('connect', () => {
          window.location.reload()
          this.isConnected = true
        })
        .on('close', () => {
          this.isConnected = false
        })
    },

    mounted() {
      this.$i18n.locale = this.locale
    },

    computed: {
      layout() {
        let layout

        // todo: temporary fix
        if (!this.isAuthenticated) {
          layout = 'auth-layout'
        } else {
          layout = (this.$route.meta.layout || defaultLayout) + '-layout'
        }

        return layout
      },

      ...mapGetters('auth', {
        isAuthenticated: 'isAuthenticated',
        currentUser: 'currentUser',
        locale: 'locale'
      })
    },

    methods: {
      watchSocketEvents() {
        this.socketChannel = socket.subscribe(this.currentUser.group_id)

        this.socketChannel.watch(eventInfo => {
          //console.log(eventInfo, 'EVENT INFO')
          let publishHandler = publishMap[eventInfo.event]

          if (publishHandler && !_.isEqual(eventInfo.auth_id, this.currentUser.auth_id)) {
            publishHandler(eventInfo)
          }
        })
      },

      stopWatchingSocketEvents() {
        if (!this.socketChannel) {
          return
        }

        this.socketChannel.unsubscribe()
      }
    },

    watch: {
      isAuthenticated: {
        handler(authenticated) {
          if (authenticated) {
            this.watchSocketEvents()

            return
          }

          this.stopWatchingSocketEvents()
        },
        immediate: true
      }
    }
  }
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
